import { render } from "./ManageCampaignPrimers.vue?vue&type=template&id=18c9e27c&scoped=true"
import script from "./ManageCampaignPrimers.vue?vue&type=script&lang=js"
export * from "./ManageCampaignPrimers.vue?vue&type=script&lang=js"

import "./ManageCampaignPrimers.vue?vue&type=style&index=0&id=18c9e27c&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c9e27c"]])

export default __exports__